// extracted by mini-css-extract-plugin
export default {"mCard":"aD-z","image":"bD-z","imageNoBackground":"cD-z","imageHasCategory":"dD-z","fullWidth":"eD-z"};